import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { DropLocation } from "../drop.types";
import { getRankHoverBorderClass } from "../dropRankStyles";
interface ParticipationDropContainerProps {
  readonly drop: ExtendedDrop;
  readonly isActiveDrop: boolean;
  readonly location: DropLocation;
  readonly children: React.ReactNode;
  readonly useRankStyles?: boolean | undefined;
  readonly floatingActions?: React.ReactNode | undefined;
}
const ACTIVE_DROP_STYLES = "tw-border tw-border-[#3CCB7F]/45 tw-shadow-[0_0_0_1px_rgba(60,203,127,0.14)]";
const getDropStyles = ({
  isActiveDrop,
  rank,
  isDrop
}: {
  isActiveDrop: boolean;
  rank: number | null;
  isDrop: boolean;
}): string => {
  if (!isDrop) {
    return "";
  }
  if (isActiveDrop) {
    return ACTIVE_DROP_STYLES;
  }
  if (rank === null) {
    return "tw-border tw-border-iron-800 desktop-hover:hover:tw-border-iron-600";
  }
  switch (rank) {
    case 1:
      return `tw-border tw-border-iron-800 ${getRankHoverBorderClass(1)}`;
    case 2:
      return `tw-border tw-border-iron-800 ${getRankHoverBorderClass(2)}`;
    case 3:
      return `tw-border tw-border-iron-800 ${getRankHoverBorderClass(3)}`;
  }
  return "tw-border tw-border-iron-800 desktop-hover:hover:tw-border-iron-700";
};
const getBackgroundClass = ({
  isActiveDrop
}: {
  isActiveDrop: boolean;
}): string => {
  if (isActiveDrop) {
    return "tw-bg-[#3CCB7F]/10";
  }
  return "tw-bg-iron-950";
};
export default function ParticipationDropContainer(t0) {
  const $ = _c(15);
  const {
    drop,
    isActiveDrop,
    location,
    children,
    useRankStyles: t1,
    floatingActions
  } = t0;
  const useRankStyles = t1 === undefined ? true : t1;
  const isDrop = drop.drop_type === ApiDropType.Participatory;
  const t2 = useRankStyles ? drop.rank : null;
  let t3;
  if ($[0] !== isActiveDrop || $[1] !== isDrop || $[2] !== t2) {
    t3 = getDropStyles({
      isActiveDrop,
      rank: t2,
      isDrop
    });
    $[0] = isActiveDrop;
    $[1] = isDrop;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const dropStyles = t3;
  let t4;
  if ($[4] !== isActiveDrop) {
    t4 = getBackgroundClass({
      isActiveDrop
    });
    $[4] = isActiveDrop;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const backgroundClass = t4;
  const t5 = `${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-w-full`;
  const t6 = `tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-xl ${backgroundClass} ${dropStyles} tw-border-solid tw-transition-[box-shadow,background-color,border-color] tw-duration-200 tw-ease-out`;
  let t7;
  if ($[6] !== children || $[7] !== t6) {
    t7 = <div className={t6}>{children}</div>;
    $[6] = children;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== floatingActions || $[10] !== t7) {
    t8 = <div className="tw-group tw-relative tw-w-full">{floatingActions}{t7}</div>;
    $[9] = floatingActions;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <div className={t5}>{t8}</div>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}